import React, { useEffect, useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Fullscreen from "./Fullscreen";
import store from "../store";
const Header = ({ toggleSidebar }) => {
  const [forceUpdate, setForceUpdate] = useState(0);

  useEffect(() => {
    setForceUpdate((prev) => prev + 1);
  }, [store?.mute]);

  return (
    <>
      <header
        key={forceUpdate}
        className="m-auto px-4 md:px-6 flex items-center justify-between border-b border-gray-300 bg-white w-full p-1 h-[50px] transition-all duration-300 z-50"
      >
        <div>
          <button
            className="text-2xl text-gray-800 md:hidden"
            onClick={toggleSidebar}
          >
            ☰
          </button>

          <span> Hello, {store.restaurantInfo?.name || ""}</span>
        </div>

        <div className="flex justify-end items-center gap-[20px]">
          <Fullscreen />
          <span className="text-white bg-[#059351] py-1 px-1 rounded-md">
            QRapid - v3.1.6
          </span>
        </div>
      </header>
    </>
  );
};

export default Header;
